module.exports = __webpack_public_path__ + "img/kaka-icon.d64fd4b3.png";